export const SUPERLOGICA = { label: 'Superlógica', value: 'SUPERLOGICA' };
export const ALMAH = { label: 'Almah Condos', value: 'ALMAH' };

export const TIPO_INTEGRACAO_ENUM_VALUES = [SUPERLOGICA, ALMAH];
